import React, { useEffect } from 'react'
import * as d3 from 'd3';
import { IonGrid, IonRow, IonCol } from '@ionic/react';

/**
 * Build pie Chart with data
 * @returns 
 * ref: https://ihsavru.medium.com/react-d3-implementing-a-pie-chart-dc7bf13ff418
 */

const PieChart = (props) => {

    // props
    const {
        data,
        outerRadius,
        innerRadius,
    } = props;

    //spacing
    const margin = {
        top: 20, right: 20, bottom: 20, left: 20,
    };

    // size - based on radius and margins
    //const width = 2 * outerRadius + margin.left + margin.right;
   // const height = 2 * outerRadius + margin.top + margin.bottom;

    // bind drawchart() to data -> prop from app.js

    useEffect(() => {
        drawChart();
    }, [data, outerRadius, innerRadius]);

    //structure data
    let cleaData = d3.rollup(data, v => d3.sum(v, d => d.amount), d => d.beneficiary);
    cleaData = Array.from(cleaData, ([beneficiary, amount]) => ({ beneficiary, amount }))

    function drawChart() {

        // map colors from -> interpolateCool. ->  https://github.com/d3/d3-scale-chromatic/blob/main/README.md
        const colorScale = d3
            .scaleSequential()
            .interpolator(d3.interpolateCool)
            .domain([0, cleaData.length]);


        // binding to dom

        // Remove the old svg
        d3.select('#pie-container')
            .select('svg')
            .remove();

        d3.select('#pie-container').select('text').remove();

        d3.select('#pie-labels')
            .select('svg')
            .remove();

        // Create new svg
        const svg = d3
            .select('#pie-container')
            .append('svg')
            .attr('id','pieChart')
            .attr('width',180)
            .attr('height',220)
            .append('g')
            .attr('transform', `translate(${180/ 2}, ${120})`);


        svg.append('text').text(d3.sum(data.map(d => d.amount)).toFixed(2) + ' CHF').attr('x', -margin.left-20);

        const labelVg = d3.select('#pie-labels')
            .append('svg')
            .attr('height',function(){return cleaData.length*25})
            .append('g')
            .attr('width', outerRadius * 3)
            .attr('transform', `translate(0, 10)`)
            .attr('height',function(){return cleaData.length*25})

        //  the arc -> why does this have 2 radius?
        const arcGenerator = d3
            .arc()
            .innerRadius(60 )
            .outerRadius( 90 );

        const pieGenerator = d3
            .pie()
            .padAngle(0)
            .value((d) => d.amount);

        /**
         * d3.arc doesn’t actually draw any arcs yet but it is used to create an arcGenerator which will be used to draw the sectors of the pie. 
         * Similarly, d3.pie doesn’t draw the pie but it used to compute the necessary angles to represent our data as a pie.
         */

        const arc = svg
            .selectAll()
            .data(pieGenerator(cleaData))
            .enter();


        // Append arcs
        arc
            .append('path')
            .attr('d', arcGenerator)
            .style('fill', (_, i) => colorScale(i))
            .style('stroke', '#ffffff')
            .style('stroke-width', 0);

        // Add one dot in the legend for each name.
        labelVg.selectAll("mydots")
            .data(cleaData)
            .enter()
            .append("circle")
            .attr("cx", 40)
            .attr("cy", function (d, i) { return i * 25 }) // 100 is where the first dot appears. 25 is the distance between dots
            .attr("r", 7)
            .style("fill", (_, i) => colorScale(i))

        // Add one dot in the legend for each name.
        labelVg.selectAll("mylabels")
            .data(cleaData)
            .enter()
            .append("text")
            .attr("x", 60)
            .attr("y", function (d, i) { return i * 25 }) // 100 is where the first dot appears. 25 is the distance between dots
            .style("fill", (_, i) => colorScale(i))
            .text(function (d) { return (d.beneficiary + ': ' + (100 * d.amount / d3.sum(data.map(d => d.amount))).toFixed(2)) + '%' })
            .attr("text-anchor", "left")
            .style("alignment-baseline", "middle")

    }

    // jsx
    return (
        <IonRow>
            <IonCol sizeXs='12'>
                <div id="pie-container">
                </div>
            </IonCol>
            <IonCol sizeXs='12'>
                <div id="pie-labels" style={{overflow:"scroll",height:"120px"}}></div>
            </IonCol>
        </IonRow>
    );
}
export default PieChart;